
{
    "safetyDataSheets": "Safety Data Sheets and Article Information Sheets",
    "bodyContentParagraph1": "Safety Data Sheets (SDS) for chemical products and Article Information Sheets (AIS), for items such as printing plates and equipment, contain country specific regulatory information.",
    "bodyContentParagraph2": "While SDSs and AISs may also be available for other products to provide guidance on their safe use and disposal, their existence does not imply that the product is subject to regulation as a chemical substance or mixture.",
    "bodyContentParagraph3": "To search for a SDS or AIS:",
    
    "bodyContentList1": "Choose a Report Category (Product SDS or Article Information Sheet).",
    "bodyContentList2": "Choose a Country/Region - Language. Note: Not all reports exist in all languages.",
    "bodyContentList3": "<strong> <b>To find SDS:</b> </strong> Enter the catalog/reorder number (with no spaces or hyphens) or the partial/full product name obtained from product label in the appropriate search field.",
    "bodyContentList4": "<strong> <b>To find AIS:</b> </strong> Enter keywords from the product name in the Product Name/Keyword search field. Examples include: color film, colour film, black and white film, black & white film, process free plate, thermal plate.",
    "bodyContentList5": "Click the search button.",

    "reportCategory" : "REPORT CATEGORY",
    "country": "COUNTRY/REGION",
    "language": "LANGUAGE",
    "catalogNumber": "CATALOG / REORDER NUMBER",
    "productName": "PRODUCT NAME / KEYWORD",
    "search": "SEARCH",

    "inquiriesSentTo": "In the event you have searched for a SDS and could not locate the information, please review the information below. Inquiries can be sent to <a href='mailto:us-pep@kodak.com'>us-pep@kodak.com</a>",
    
    "platesAndEquipment": "Plates and Equipment",
    "platesAndEquipmentContent" : "KODAK Plates and KODAK Equipment do not require a SDS because under normal conditions these products do not pose a physical hazard or health risk.",
    
    "kodakBrandPartner": "Kodak Brand Partner Products",
    "kodakBrandPartnerContent" : "The information you are requesting may be for a product which is sold by a company considered a Kodak Brand Partner. In this case, contact our Kodak Brand Partner directly for SDS or product information.",
    
    "batteries": "Batteries",
    "strandEurope": "Please contact Strand Europe at <a href='https://www.kodakbatteries.strandeurope.com' target='_blank' >www.kodakbatteries.strandeurope.com</a>",
    
    "consumerAndProfessionalPhotographicProducts": "Consumer and Professional Photographic Products and Document Scanners",
    "kodakAlaris": "Please contact Kodak Alaris at <a href='https://www.kodakalaris.com' target='_blank'>www.kodakalaris.com</a>",
    
    "divestedProducts": "Divested Products",
    "devistedProductsContent": "The information you are requesting may be for a product which has been sold to another company as part of a divestiture. In this case, contact that company directly for SDS or product information.",
    
    "medicalDentalAndIndustrialXrayProducts": "Medical, Dental and Industrial X-ray Products",
    "carestreamHealth": "Please contact Carestream Health, Inc. at <a href='https://www.carestream.com' target='_blank' >www.carestream.com</a>",
    
    "laboratoryAndResearchChemicals": "Laboratory and Research Chemicals",
    "fisherChemicalCompany": "Please contact Fisher Chemical Company at <a href='https://www.fishersci.com' target='_blank' >www.fishersci.com</a>",
    
    "fibersAndPlastics": "Fibers and Plastics",
    "eastmanChemicalCompany": "Please contact Eastman Chemical Company at <a href='https://www.eastman.com' target='_blank'>www.eastman.com</a>",
    
    "copyright": "Copyright ©2024 Eastman Kodak Company. All Rights Reserved.",

    "termsOfUse": "Terms Of Use",
    "privacy": "Privacy",
    "accessibility": "Accessibility",
    "GridHeaders": {
      "Report Category":"Report Category",
      "Country":"Country",
      "Language":"Language",
      "Document Revision Number":"Revision #",
      "CatalogNumber":"Catalog/Reorder No.",
      "Document Name": "Document Name"
    },
    "HeaderLinks":"https://www.kodak.com/en",

    "FallbackMessage":"Sorry for the inconvenience. The service is currently unavailable, please try again later.",
    "report_Categories_dropdown": [
      {"CatogeryType":"SDS" ,"displayName": "Product SDS" },
      {"CatogeryType":"AIS" ,"displayName":"Article Information Sheet"},
      {"CatogeryType":"DGW","displayName": "Dangerous Goods (DG) Worksheet"}
    ]
  }
  